import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getMedia } from '../../../../actions/media/media';
import { updateTodoList } from '../../../../actions/todo_list/todo_list';
import Prismic from 'prismic-javascript';
import { RichText } from "prismic-reactjs";
import { withRouter } from 'react-router';
import { PrismicConfigMarketingPage } from '../../../../helpers/prismicHelpers/PrismicAPI';
import { singleArticleHelper, articlesListHelper, categoryHelper, categoriesHelper } from '../../../../helpers/prismicHelpers/prismic-custom-helpers/BlogHelpers';
import { prismicSliceHelper, prismicSliceContentRelationship } from "../../../../helpers/prismicHelpers/prismic-slice-helpers/PrismicSliceHelpers";
import { sliceComponentsHelper } from "../../../../helpers/prismicHelpers/prismic-slice-helpers/SliceComponentsHelpers";
import Loader from '../../../common/elements/Loader';
import { BlogHero } from './BlogHero';
import { BlogLatestArticles } from './BlogLatestArticles';
import CategoryMenu from './CategoryMenu';
import { siteOfOriginHelper } from '../../../../../client/helpers/genericHelpers';
import { BackButton } from '../../../common/elements';
// import { BackButton } from '../../../dashboardNew/components/tools/BackButton';

class SingleArticlePage extends Component {

    state = {
        loading         : true,
        slices          : null,
        articlesList    : null,
        categories      : null,
        category        : null,
        singleArticle   : null,
        languagePrismic : null
    }

    componentDidMount = () => this.updateContent()
    componentDidUpdate = prevProps => prevProps.params.uid !== this.props.params.uid && this.updateContent()
    redirectToMainPage = () => this.props.router.push( '/blog' )

    async updateContent(){
        setTimeout(() => this.props.updateTodoList( localStorage.getItem('person_id'), 6 ), 120000);
        
        const languagePrismic = { lang: `en-${siteOfOriginHelper()}` }

        try {
            const prismicConnection = await Prismic.api(PrismicConfigMarketingPage.apiEndpoint, { accessToken: PrismicConfigMarketingPage.apiAccessToken });
            //Key value pairs to fetch on list page
            const arrayToFetch = [
                'blog-single-article.uid',
                'blog-single-article.article_small_img',
                'blog-single-article.article_date',
                'blog-single-article.alternative_text_image',
                'blog-single-article.article_title',
                'blog-single-article.article_short_description'
            ];

            //If there is no UID
            if( !this.props.params.uid.length ){ return this.redirectToMainPage() };
            //if there is UID
            const json = await Promise.all([

                prismicConnection.query( Prismic.Predicates.at('document.type', 'blog-single-article'),
                    {
                        orderings   : '[my.blog-single-article.article_date desc]',
                        fetch       : arrayToFetch, 
                        pageSize    : 3,
                        ...languagePrismic
                    }
                ),
                prismicConnection.query( Prismic.Predicates.at( 'my.blog-single-article.uid', this.props.params.uid ), languagePrismic ),
                prismicConnection.query( Prismic.Predicates.at( "document.type", "blog-categories" ), languagePrismic )

            ]);

            //if there is no object with UID like this one
            if( !json[1].results || !json[1].results.length ){ return this.redirectToMainPage() };

            let { slices } = prismicSliceHelper(json[1]);
            slices = slices && slices.length ? await prismicSliceContentRelationship( slices, prismicConnection, languagePrismic ) : null;

            //if UID exists in our db
            let newState = {
                ...articlesListHelper( json[0] ),
                ...singleArticleHelper( json[1] ),
                ...categoriesHelper( json[2] ),
                slices,
                languagePrismic
            };

            if( newState.singleArticle && newState.singleArticle.category_id ){
                newState.category = categoryHelper( categoriesHelper( json[2] ), newState.singleArticle.category_id )
            };

            this.setState({
                ...newState,
                loading: false
            });
        } catch (err) {
            return { error: true, err };
        };
    }

    content(){
        if( !this.state.slices || !this.state.slices.length ){
            return [
                <section key="1" className="rich-text container position-relative mt-4 mb-4">,
                <BackButton  key="2" />
                    <div className="text-max-width">
                        { RichText.render( this.state.singleArticle.long_description ) }
                    </div>   
                </section>
            ];
        };
        return sliceComponentsHelper( this.state.slices, this.state.languagePrismic );
    }

    render() {
        if( this.state.loading ){ return <Loader /> };

        return (
            <React.Fragment>
                <BlogHero
                    date={ this.state.singleArticle.date }
                    title={ this.state.singleArticle.title }
                    background={ this.state.singleArticle.big_img }
                    description={ this.state.singleArticle.short_description }
                    languagePrismic={ this.state.languagePrismic }
                />
                { this.state.singleArticle.is_on_portal && <h2 classname="h2">ONLY ON THE PORTAL ----> UNIQUE</h2> }
                { this.state.categories && <CategoryMenu categories={ this.state.categories } current_category={ null } /> }
                { this.content() }
                <BlogLatestArticles articlesList={ this.state.articlesList } languagePrismic={ this.state.languagePrismic }/>
            </React.Fragment>
        );
    }
};

const mapDispatchToProps = dispatch => ({
    getMedia: ( page ) => dispatch( getMedia( page ) ),
    updateTodoList: (personId, listItem) => dispatch( updateTodoList(personId, listItem) )
});

export default withRouter( connect( null, mapDispatchToProps)( SingleArticlePage ) );


// WEBPACK FOOTER //
// src/client/components/site/features/blogs/SingleArticlePage.js